import { Header } from "@/components/header";

/**
 * Shared shell for the standalone legal pages (Privacy Policy, Acceptable Use
 * Policy). Keeps the header, title block, section rhythm and footer consistent
 * with /terms without duplicating markup.
 *
 * `sections` is an array of { id, heading, content } where `content` is JSX.
 */
export function LegalPage({ title, version = "1.0", effective, intro, sections }) {
  return (
    <div className="relative min-h-screen bg-transparent">
      <Header />
      <main className="container relative z-10 mx-auto max-w-3xl scroll-smooth px-4 py-12 lg:py-16">
        <div
          id="top"
          className="flex flex-wrap items-baseline justify-between gap-3 border-b border-border pb-5"
        >
          <span className="font-display text-2xl font-bold tracking-tight">Subiza</span>
          <span className="font-mono text-xs uppercase tracking-widest text-muted">{title}</span>
        </div>

        <div className="py-10">
          <p className="mb-4 font-mono text-sm text-muted">
            Effective {effective} &middot; Version {version}
          </p>
          <h1 className="font-display text-4xl font-bold tracking-tight text-balance lg:text-5xl">
            {title}
          </h1>
          <p className="mt-3 text-lg leading-relaxed text-muted">{intro}</p>
        </div>

        {sections.map((s) => (
          <section key={s.id} id={s.id} className="mt-8 scroll-mt-24 border-t border-border pt-8">
            <h2 className="font-display text-2xl font-bold tracking-tight text-balance">
              {s.heading}
            </h2>
            <div className="mt-4 space-y-4 leading-relaxed">{s.content}</div>
          </section>
        ))}

        <footer className="mt-12 flex flex-wrap items-center justify-between gap-2.5 border-t border-border pt-6 text-sm text-muted">
          <span>
            Subiza {title} &middot; Version {version}
          </span>
          <a
            href="#top"
            className="underline underline-offset-2 transition-colors hover:text-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
          >
            Back to top
          </a>
        </footer>
      </main>
    </div>
  );
}
